import { Equal } from "./equal";
export var Result;
(function (Result) {
    /**
     * Success
     */
    class Value {
        constructor(value) {
            this.value = value;
        }
        getValue() {
            return this.value;
        }
        static equal(valueEquals) {
            return Equal.object({ value: valueEquals });
        }
    }
    Result.Value = Value;
    /**
     * Error
     */
    class Error {
        constructor(error) {
            this.error = error;
        }
        getValue() {
            throw this.error;
        }
    }
    Error.EQUAL = Equal.object({ error: Equal.identity() });
    Result.Error = Error;
    function equal(valueEquals) {
        const errorEquals = Error.EQUAL;
        const valueEquals_ = Value.equal(valueEquals);
        return (a, b) => {
            if (a === b) {
                return true;
            }
            if (a instanceof Result.Error) {
                return b instanceof Result.Error && errorEquals(a, b);
            }
            return b instanceof Result.Value && valueEquals_(a, b);
        };
    }
    Result.equal = equal;
    function run(f) {
        try {
            const result = f();
            return new Result.Value(result);
        }
        catch (e) {
            return new Result.Error(e);
        }
    }
    Result.run = run;
})(Result || (Result = {}));
//# sourceMappingURL=result.js.map